import CompositionApi, { ref } from "@vue/composition-api";
import Vue from "vue";
Vue.use(CompositionApi);

const isLoading = ref(false);

export default isLoading;
